import type { ComponentType, ExoticComponent } from 'react';
import { memo } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import type { ListChildComponentProps, VariableSizeListProps } from 'react-window';
import { VariableSizeList as List } from 'react-window';
import type { MetricEntry } from '../types';
import { TableCell, TableRow } from '@mui/material';
import { MetricChip, MetricInput } from './MetricsComponents';

const VariableSizeList = List as unknown as ComponentType<VariableSizeListProps>;

interface IProps {
  items: MetricEntry[];
}

// eslint-disable-next-line react/display-name
const EditMetricDescriptionListItem: ExoticComponent<ListChildComponentProps<MetricEntry[]>> = memo(
  ({ data, index, style }) => {
    const metric = data[index];

    return (
      <TableRow style={style} sx={{ td: { height: 64, px: 2 } }}>
        <TableCell sx={{ width: '280px' }}>
          <MetricChip label={metric.name} />
        </TableCell>
        <TableCell sx={{ width: '80%' }}>
          <MetricInput name={`items.${index}.description`} style={{ width: 300, height: 38, padding: '8px 12px' }} />
        </TableCell>
      </TableRow>
    );
  }
);

// eslint-disable-next-line react/display-name
const EditMetricDescriptionList: ExoticComponent<IProps> = memo(({ items }) => {
  return (
    <AutoSizer>
      {({ height, width }) => (
        <VariableSizeList height={height} itemCount={items.length} itemSize={() => 64} width={width} itemData={items}>
          {/*falls locally, but fine in pipeline*/}
          {EditMetricDescriptionListItem as any}
        </VariableSizeList>
      )}
    </AutoSizer>
  );
});

export default EditMetricDescriptionList;
